import { createStore } from "ui.vue3.vuex";

export const store = createStore({
  state() {
    return { params: {} };
  },
  getters: {
    getFilteredProducts: (state) => (searchValue) => {
      return state.params.products.filter((product) => {
        if (!searchValue) return product;

        if (product.NAME.toLowerCase().includes(searchValue.toLowerCase()))
          return product;
      });
    },
  },
  mutations: {
    setGlobalParams(state, payload) {
      state.params = payload;
    },
  },
  actions: {
    setGlobalParams(context, payload) {
      context.commit("setGlobalParams", payload);
    },
  },
});
